import { apiUrls } from "../../utils/app-constants";
import { apiSlice } from "../services/apiSlice";

export const ccQueryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllQuery: builder.query({
      query: (params) => {
        const searchParams = new URLSearchParams(params).toString();
        return {
          url: `/admin/query?${searchParams}`,
          method: "GET",
        };
      },
      providesTags: ["user"],
    }),
    // sendCoin: builder.mutation({
    //   query: ({ data, slug }) => ({
    //     url: `/admin/user/${slug}/coins/`,
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: ["user"],
    // }),
    // blockUnblockUser: builder.mutation({
    //   query: ({ id }) => ({
    //     url: `/admin/user/${id}/status`,
    //     method: "PATCH",
    //   }),
    //   // invalidatesTags: ["user"],
    // }),
    // deleteUser: builder.mutation({
    //   query: (id) => ({
    //     url: `${apiUrls.deleteUser}/${id}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["user"],
    // }),
    // dashboardData: builder.query({
    //   query: () => ({
    //     url: `users`,
    //     method: "GET",
    //   }),
    // }),
    // graphData: builder.query({
    //   query: () => ({
    //     url: `${apiUrls.graph}`,
    //     method: "GET",
    //   }),
    // }),
    // sendPush: builder.mutation({
    //   query(body) {
    //     return {
    //       url: `${apiUrls.sendPush}`,
    //       method: "post",
    //       body,
    //     };
    //   },
    // }),
  }),
});

export const {
  useGetAllQueryQuery,
  // useSendCoinMutation,
  // useBlockUnblockUserMutation,
  // useDeleteUserMutation,
  // useDashboardDataQuery,
  // useGraphDataQuery,
  // useSendPushMutation,
} = ccQueryApi;
